import React from 'react';

const RegulamentoSP = () => {
  return (
    <>
      <h1 className="title">Regulamento</h1>
      <div className="content">
        <h2>CAPÍTULO I – DO PRÊMIO</h2>
        <p>
          <strong>Art. 1º</strong> – O Prêmio Padocaria-SP contribui para a
          valorização e o reconhecimento das padarias, de seus profissionais, de
          seus serviços e de seus produtos, que ajudam a construir a convivência
          e a gastronomia na cidade de São Paulo. A partir da edição de 2025,
          passou a abranger também o município de Guarulhos.
        </p>
        <br />
        <p>
          <strong>Art. 2º</strong> – Atuando diretamente na valorização das
          padarias, o Padocaria-SP também contribui para estimular a população a
          reconhecer e a valorizar as padarias de sua comunidade, de seu bairro
          e de sua cidade.
        </p>
        <br />
        <p>
          <strong>Art. 3º</strong> – O Prêmio Padocaria-SP foi idealizado e é
          promovido pela M.Pad Produções, Marketing e Conteúdo (razão social:
          Miguel Angelo Padberg Icassatti).
        </p>
        <br />

        <h2>CAPÍTULO II – DA PARTICIPAÇÃO</h2>
        <p>
          <strong>Art. 1º</strong> – A Fase 1 do Padocaria-SP é aberta a votação
          do público consumidor, que pode indicar seus votos a quaisquer
          padarias estabelecidas dentro dos limites da cidade de São Paulo nas
          seguintes categorias: 1) Pãozinho; 2) Pão de Fermentação Natural; 3)
          Time de Chapeiros; 4) Pizza de padoca; 5) Almoço em padaria; 6) Café;
          7) Vitrine de confeitaria; 8) Melhor Padaria de São Paulo. O público
          também pode votar na categoria 9) Melhor Padaria de Guarulhos.
        </p>
        <br />
        <p>
          <strong>Art. 2º</strong> – A Fase 2 do Padocaria-SP é aberta às cinco
          padarias paulistanas com maior número de votos, na soma de todas as
          categorias, em cada uma das cinco regiões da cidade de São Paulo, de
          acordo com as faixas de CEP: Zonas Norte, Sul, Leste, Oeste e Centro e
          às três padarias com maior número de votos, na soma de todas as
          categorias, da cidade de Guarulhos. Também nessa fase, as 25
          finalistas de São Paulo concorrem automaticamente aos prêmios nas
          categorias Melhor equipe de caixa apresentada por Mondeléz, Melhor Pão
          na chapa com Catupiry e Melhor Serviço de frios apresentado por Seara.
          As 3 padarias mais votadas em Guarulhos na Fase 1 avançam à Fase 2.
        </p>
        <br />

        <h2>CAPÍTULO III – DAS POSSIBILIDADES DE PREMIAÇÃO</h2>
        <p>
          <strong>Art. 1°</strong> – Na Fase 1, uma padaria poderá ser premiada
          em até três categorias e poderá sagrar-se vencedora em apenas uma
          categoria, ainda que receba o maior número de votos em duas ou mais
          categorias. Caso ela receba o maior número de votos em mais de uma
          categoria, ela será considerada, para fins de premiação, a vencedora
          apenas da categoria em que tiver recebido o maior número de votos
          absolutos.
        </p>
        <br />
        <p>
          <strong>Art. 2º</strong> – Na Fase 1, a padaria poderá ser considerada
          a 2ª colocada apenas na categoria na qual recebeu o maior número de
          votos, exceto na categoria da qual foi a vencedora.
        </p>
        <br />
        <p>
          <strong>Art. 3º</strong> – Na Fase 1, a padaria poderá ser considerada
          a 3ª colocada apenas na categoria na qual recebeu o maior número de
          votos, exceto na categoria na qual foi a vencedora e na categoria na
          qual foi a 2ª colocada.
        </p>
        <br />
        <p>
          <strong>Art. 4º</strong> – Em caso de empate na Fase 1, será
          considerado como critério de desempate o número total de votos
          recebidos pela padaria em todas as categorias. Ao persistir o empate,
          o prêmio será dividido e entregue a ambas.
        </p>
        <br />
        <p>
          <strong>Art. 5º</strong> – Para a Fase 2 serão levadas 28 padarias com
          mais indicações na Fase 1, assim distribuídas e organizadas: as 5 com
          mais indicações localizadas na Zona Norte; as 5 com mais indicações
          localizadas na Zona Leste; as 5 com mais indicações localizadas na
          Zona Sul; as 5 com mais indicações localizadas na Zona Oeste; as 5 com
          mais indicações localizadas na região central e as 3 com mais
          indicações localizadas na cidade de Guarulhos.
        </p>
        <br />

        <h2>CAPÍTULO IV – DA INDICAÇÃO E DA VOTAÇÃO</h2>
        <p>
          <strong>Art. 1º</strong> – A premiação se dará por indicação e voto
          realizados em duas fases, única e exclusivamente por meio da
          plataforma digital{' '}
          <a
            href="https://www.padocariasp.com.br"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#40b2f5', textDecoration: 'underline' }}
          >
            www.padocariasp.com.br
          </a>
          .
        </p>
        <br />
        <p>
          <strong>Art. 2º</strong> – Na Fase 1, a seleção dos indicados em cada
          categoria se dará apenas pelo voto do público, que pode indicar apenas
          1 (um) estabelecimento em cada uma das categorias.
        </p>
        <br />
        <p>
          <strong>Art. 3º</strong> – É permitido indicar a mesma Padaria em uma
          ou mais categorias assim como é permitido indicar uma padaria
          diferente para cada categoria.
        </p>
        <br />
        <p>
          <strong>Art. 4º</strong> – Não é permitido voto em branco.
        </p>
        <br />
        <p>
          <strong>Art. 5º</strong> – Cada pessoa pode votar somente uma vez em
          cada categoria, em cada uma das fases, mediante validação prévia de
          cadastro. Serão considerados válidos as indicações e os votos feitos
          no período de: 10 a 27 de setembro de 2026 (Fase 1); 9 a 29 de outubro
          de 2026 (Fase 2).
        </p>
        <br />
        <p>
          <strong>Art. 6º</strong> – A Fase 1 começa às 10h do dia 10 de
          setembro de 2026 e se encerra às 23h59 do dia 27 de setembro de 2026.
          A Fase 2 começa às 10h do dia 9 de outubro de 2026 e se encerra às
          23h59 do dia 29 de outubro de 2026.
        </p>
        <br />
        <p>
          <strong>Art. 7º</strong> – Na Fase 2, haverá a participação do júri
          técnico, formado por profissionais de comunicação e de gastronomia,
          bem como convidados pela organização do Padocaria-SP, cuja identidade
          será mantida em sigilo. Esses jurados técnicos não possuem nenhum
          vínculo comercial com as padarias finalistas.
        </p>
        <br />
        <p>
          <strong>Art. 8º</strong> – Na Fase 2, a soma dos votos do júri técnico
          terá peso de 50% na apuração do resultado. Os outros 50% se darão com
          a soma total de votos recebidos pelo público.
        </p>
        <br />
        <p>
          <strong>Art. 9°</strong> – O Padocaria-SP se compromete a manter a
          confidencialidade das indicações e votos de cada votante. As
          informações e os resultados a serem divulgados não estarão atrelados a
          nenhuma fonte específica e serão apresentados no conjunto da
          premiação.
        </p>
        <br />
        <p>
          <strong>Art. 10º</strong> – Na Fase 2, o Padocaria-SP reserva-se o
          direito de penalizar e/ou desqualificar uma padaria finalista caso ela
          não instale o enxoval promocional disponibilizado pela organização do
          concurso em seu estabelecimento (banner, móbiles, display, sacolas de
          pão, saco de pão e materiais similares).
        </p>
        <br />
        <p>
          <strong>Art. 11º</strong> – Para a categoria “Melhor Pão na Chapa com
          Catupiry” serão considerados os votos válidos apenas para as padarias
          que tenham adquirido e utilizado produtos Catupiry regularmente. Para
          comprovação, a organização faculta o direito de solicitar a
          apresentação, por parte da padaria finalista, de nota fiscal de compra
          do produto com data anterior à data de início da fase 2.
        </p>
        <br />
        <p>
          <strong>Art. 12º</strong> – Para a categoria “Melhor Equipe de caixa
          apresentada por Mondeléz” serão considerados os votos válidos apenas
          para as padarias que tenham adquirido e utilizado produtos Mondelez
          regularmente. Para comprovação, a organização faculta o direito de
          solicitar a apresentação, por parte da padaria finalista, de nota
          fiscal de compra do produto com data anterior à data de início da fase
          2.
        </p>
        <br />
        <p>
          <strong>Art. 13º</strong> – Para a categoria “Melhor Serviço de Frios
          apresentado por Seara” serão considerados os votos válidos apenas para
          as padarias que tenham adquirido e utilizado produtos Seara
          regularmente. Para comprovação, a organização faculta o direito de
          solicitar a apresentação, por parte da padaria finalista, de nota
          fiscal de compra do produto com data anterior à data de início da fase
          2.
        </p>
        <br />
        <p>
          <strong>Art. 14º</strong> – Serão consideradas padarias “Hors
          Concours” aquelas que tiverem sido campeãs de uma mesma categoria em
          três edições do Padocaria-SP. Os votos a elas conferidos serão
          desconsiderados na presente edição, para aquela respectiva categoria.
          Essas padarias concorrem normalmente nas demais categorias.
        </p>
        <br />

        <h2>CAPÍTULO V – DOS RESULTADOS</h2>
        <p>
          <strong>Art. 1°</strong> – Serão concedidos prêmios (troféus e/ou
          diplomas) aos vencedores de cada categoria. Na Fase 1: 1) Pãozinho; 2)
          Pão de Fermentação Natural; 3) Time de Chapeiros; 4) Pizza de padoca;
          5) Almoço em padaria; 6) Café; 7) Vitrine de confeitaria.
          <br />
          <br />
          Na Fase 2: 1) Melhor Padaria da Zona Norte; 2) Melhor Padaria da Zona
          Leste; 3) Melhor Padaria da Zona Oeste; 4) Melhor Padaria da Zona Sul;
          5) Melhor Padaria da Região Central; 6) Melhor Padaria de Guarulhos;
          7) Melhor equipe de caixa, apresentada por Mondeléz; 8) Melhor pão na
          chapa com Catupiry; 9) Melhor Serviço de Frios, apresentado por Seara;
          10) Destaque Padaria Sustentável.
          <br />
          <br />
          Serão concedidos prêmios à Melhor Padaria de São Paulo e à Melhor
          Padaria de Guarulhos através da soma total de votos recebidos em todas
          as categorias, no conjunto das duas fases.
        </p>
        <br />
        <p>
          <strong>Art. 2º</strong> – Serão concedidos diplomas de finalistas na
          Fase 2 às 5 (cinco) padarias de cada região com mais votos somados em
          todas as categorias da Fase 1: 1) Padaria da Zona Norte; 2) Padaria da
          Zona Leste; 3) Padaria da Zona Sul; 4) Padaria da Zona Oeste; 5)
          Padaria da Região Central. Serão concedidos diplomas de finalistas às
          3 (três) Padarias mais votadas de Guarulhos.
        </p>
        <br />
        <p>
          <strong>Art. 3º</strong> – Serão concedidos menção e troféu às
          padarias que alcançarem o 2º e o 3º lugares na votação das categorias
          da Fase 1 contidas neste regulamento.
        </p>
        <br />
        <p>
          <strong>Art. 4º</strong> – Será enviado por e-mail certificado de
          participação digital a todas as padarias que receberam pelo menos uma
          indicação na Fase 1, desde que se consiga obter um e-mail para contato
          e envio do mesmo.
        </p>
        <br />

        <h2>CAPÍTULO VI – DA DIVULGAÇÃO DO RESULTADO E ENTREGA DOS PRÊMIOS</h2>
        <p>
          <strong>Art. 1°</strong> – Os resultados serão divulgados no dia 4 de
          novembro de 2026 na plataforma{' '}
          <a
            href="https://www.padocariasp.com.br"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#40b2f5', textDecoration: 'underline' }}
          >
            www.padocariasp.com.br
          </a>{' '}
          e redes sociais do Padocaria-SP.
        </p>
        <br />
        <p>
          <strong>Art. 2°</strong> – No dia 4 de novembro de 2026 acontecerá o
          evento de premiação, com entrega dos troféus e certificados aos
          vencedores de cada categoria.
        </p>
        <br />

        <h2>CAPÍTULO VII – DAS CONSIDERAÇÕES FINAIS</h2>
        <p>
          <strong>Art. 1°</strong> – Ao participarem do evento de premiação, os
          presentes autorizam automaticamente o Padocaria-SP a utilizar, editar,
          publicar, reproduzir por meio impresso, digital, redes sociais e
          outros meios de comunicação visual: imagens, conteúdos, enfim, toda e
          qualquer informação do participante relacionada ao prêmio.
        </p>
        <br />
        <p>
          <strong>Art. 2°</strong> – Os resultados decorrentes da premiação e
          divulgados pelo Padocaria-SP são inquestionáveis e irrecorríveis.
        </p>
        <br />
        <p>
          <strong>Art. 3°</strong> – Os vencedores poderão utilizar, para fins
          de divulgação, o prêmio Padocaria-SP em seu estabelecimento e em todos
          os seus materiais e redes sociais. A logomarca do Padocaria-SP não
          poderá, em nenhuma circunstância, ter o seu conteúdo, cor ou formato
          alterados. Para a utilização de qualquer outra logomarca, nome ou
          material de propriedade do Padocaria-SP, será necessária autorização.
        </p>
        <br />
        <p>
          <strong>Art. 4°</strong> – A participação no Padocaria-SP implica a
          aceitação irrestrita deste regulamento.
        </p>
        <br />
        <p>
          <strong>Art. 5º</strong> – Os casos omissos a este regulamento serão
          decididos pelos organizadores.
        </p>
        <br />
      </div>
    </>
  );
};

export default RegulamentoSP;
